module.exports = __webpack_public_path__ + "static/media/default-user.68f2a6aa.svg";